import useMediaQuery from '@material-ui/core/useMediaQuery';

function IsLargeScreen() {
  const matches = useMediaQuery("(min-width:959px)");

  return matches;
}

export default IsLargeScreen;
